// extracted by mini-css-extract-plugin
export default {"root":"IconArrowHead_root__3e0TK"};